'use client';

import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import Button from '@/components/Button';
import '@splidejs/react-splide/css';
import { getStrapiImageUrl } from '@/app/lib/util';
import {HeroProps} from "@/app/types/flexible-content.types";

interface CallToActionItemProps {
	title: string
	content: string
}


export default function Hero(props: { data: HeroProps }) {
    return (
        <>
            <section className="py-8 xl:py-28 bg-cover bg-center" style={{backgroundImage: `url(${getStrapiImageUrl(props.data.BackgroundImage)})`}}>
				<div className="container flex flex-col lg:flex-row items-center justify-between">
					<div className="w-full lg:w-1/2">
						<h1 className="text-5xl lg:text-6xl font-bold mb-8 text-white">
							<ReactMarkdown
								// @ts-expect-error
								rehypePlugins={[rehypeRaw]}
								className="titlespan"
							>
								{props.data.Title}
							</ReactMarkdown>
						</h1>
						{props.data.Reason ? (
							<div className="grid grid-cols-1 gap-2 lg:gap-3 mb-12 text-xl font-medium">
								{props.data.Reason.map((item, index: number) => (
									<div className="flex items-start justify-start text-sm lg:text-base text-white" key={index}><FontAwesomeIcon icon={faCheck} className="mr-3 text-[#43C265]" />{item.Value}</div>
								))}
							</div>
						) : null}
						{props.data.ButtonGroup ? (
							<>
								{props.data.ButtonGroup.map((button, index: number) => (
									<Button key={index} link={button.ButtonLink} class="px-12 justify-center hidden text-xl lg:inline-flex text-white" label={button.ButtonLabel} />
								))}
							</>
						) : null}

					</div>
					<div className="w-full lg:w-1/2 items-end md:justify-end flex flex-col h-full">
						<div className={"bg-[#473BD0] w-[206px] h-[206px] rounded-full text-white flex items-center justify-center flex-col ml-auto text-center lg:mt-40"}>
							<strong className="opacity-70 text-lg leading-5">Get started<br />with as little as</strong>
							<div className="font-bold text-4xl">30 coins</div>
							<strong className="opacity-70 ">(1 coin = £30)</strong>
						</div>
						{props.data.ButtonGroup ? (
							<>
								{props.data.ButtonGroup.map((button, index: number) => (
									<Button key={index} link={button.ButtonLink} class="px-12 rounded-lg text-xl relative top-[-20px] justify-center flex w-full lg:w-auto lg:hidden text-white" label={button.ButtonLabel} />
								))}
							</>
						) : null}
					</div>
				</div>
			</section>
        </>
    )
}
